import { RG_TYPE, RgCreate, DefaultBuilding } from "@project-rouge/rg-core";
import { getRgObjectsOfType, getLinesFromPolygon, LineV3toLine3, getPolygonArea } from "@project-rouge/rg-three";
import seedrandom from "seedrandom";
import { addThreadsToPolys } from "./index189.js";
import { getAdjacencyWeightMod } from "./index190.js";
import { getLineLengthWeightMod } from "./index191.js";
import { getNorthWeightMod } from "./index192.js";
import { getSiteBoundaryWeightMod } from "./index193.js";
import { getThreadsFromBuilding } from "./index194.js";
import { LoadMode } from "./index195.js";
import { mainThreadToAnatomy } from "./index196.js";
import { ThreadData } from "./index197.js";
import { getActiveZones } from "./index186.js";
const pipeTailor = ([parent, { aggProps }]) => {
  const collection = [];
  const dataset = aggProps.dataset;
  const sites = getRgObjectsOfType(parent, RG_TYPE.Site);
  const sitePolys = sites.map((s) => s.data.polygon);
  const siteEdges = sitePolys.flatMap((p) => getLinesFromPolygon(p).map(LineV3toLine3));
  const zones = getActiveZones(parent, aggProps);
  const context = ThreadData.getThreadContext(dataset);
  const frozenZones = getRgObjectsOfType(parent, RG_TYPE.Zone).filter((z) => !zones.includes(z));
  const frozenBuildings = getRgObjectsOfType(frozenZones, RG_TYPE.Building);
  const frozenThreadsPerBuilding = frozenBuildings.map((b) => getThreadsFromBuilding(b, context));
  const frozenThreads = frozenThreadsPerBuilding.flat();
  const mainFrozenThreads = frozenThreadsPerBuilding.map((t) => t[0]);
  for (const zone of zones) {
    const plots = getRgObjectsOfType(zone, RG_TYPE.Plot);
    const zoneID = zone.uuid;
    const { skeletonTailorSeed, floors, siteBoundaryFactor, avoidNorthFactor, avoidNorthRange, adjacencyFactor, maxWingLength } = aggProps.zones[zoneID];
    for (const plot of plots) {
      const plotEdges = getLinesFromPolygon(plot.data.polygon).map(LineV3toLine3);
      const lineLengthWeightMod = getLineLengthWeightMod();
      const siteBoundaryModifier = getSiteBoundaryWeightMod({ siteEdges, siteBoundaryFactor });
      const northModifier = getNorthWeightMod({ avoidNorthFactor, avoidNorthRange });
      const adjacencyWeightMod = getAdjacencyWeightMod({ plotEdges, adjacencyFactor });
      const edgeWeightMods = [lineLengthWeightMod, siteBoundaryModifier, northModifier, adjacencyWeightMod];
      collection.push({
        zone,
        plot,
        rng: skeletonTailorSeed !== void 0 ? seedrandom(`${skeletonTailorSeed}`) : void 0,
        floors,
        edgeWeightMods,
        maxWingLength
      });
    }
  }
  collection.sort((a, b) => getPolygonArea(a.plot.data.polygon) - getPolygonArea(b.plot.data.polygon));
  const polysDataV3 = collection.map((c) => ({
    poly: c.plot.data.polygon,
    holes: c.zone.data.holes,
    rng: c.rng,
    edgeWeightMods: c.edgeWeightMods,
    maxWingLength: c.maxWingLength
  }));
  const { mainThreads } = addThreadsToPolys({ dataset, polysDataV3, loadMode: LoadMode.dynamic, frozenThreads });
  for (let i = 0; i < mainThreads.length; i++) {
    collection[i].mainThread = mainThreads[i];
  }
  for (const { mainThread, floors, plot } of collection) {
    if (!mainThread)
      continue;
    const joint = mainThreadToAnatomy(mainThread.data, floors);
    const building = RgCreate({ ...DefaultBuilding, parent: plot }, dataset.rvData);
    building.data.anatomy = joint;
    plot.children.push(building);
  }
  const returnData = [
    parent,
    {
      mainThreads: mainThreads.filter((t) => t).map((t) => t.data),
      mainFrozenThreads
    }
  ];
  return returnData;
};
export {
  pipeTailor
};
//# sourceMappingURL=index109.js.map
